import React from 'react'
import { Box, Typography } from '@mui/material'
import { ArrowUpward, ArrowDownward } from '@mui/icons-material'
import { green, red, grey } from '@mui/material/colors'

export default function ComparisonBadge({ value, invertColors = false }) {
  if (value === 0 || value === undefined || value === null) {
    return (
      <Typography variant="caption" sx={{ color: grey[500] }}>
        --
      </Typography>
    )
  }

  const isPositive = value > 0
  const isGood = invertColors ? isPositive : !isPositive
  const color = isGood ? green[500] : red[500]

  return (
    <Box display="flex" alignItems="center" gap={0.3}>
      {isPositive
        ? <ArrowUpward sx={{ fontSize: 14, color }} />
        : <ArrowDownward sx={{ fontSize: 14, color }} />
      }
      <Typography variant="caption" sx={{ color, fontWeight: 600 }}>
        {Math.abs(value)}%
      </Typography>
    </Box>
  )
}
